import React from 'react';


const DownloadBookletButton = ({
  pdfPath = '/cartillas/cartilla-proyecto.pdf',
  label = 'Descargar Cartilla de proyecto',
}) => {
  const handleClick = () => {
    window.open(pdfPath, '_blank', 'noopener,noreferrer');
  };

  return (
    <button className="download-booklet-btn" onClick={handleClick}>
      {label}
    </button>
  );
};

export default DownloadBookletButton;
